import React, { useEffect, useState } from 'react';

// Material UI imports
import CloseIcon  from '@mui/icons-material/Close';
import Collapse   from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Alert      from '@mui/material/Alert';


const Notification = ({severity, message, onClose, scroll=false}) => {
    const [open, setOpen] = useState(true);

    useEffect(() => {
        scrollToAlert();
    }, [open]);

    const handleClose = () => {
        setOpen(false);
        if (onClose) {
            onClose();
        }
    }

    const scrollToAlert = () => {
        if (!scroll) return;
        const alertEl = document.getElementById('notification-alert');
        if (alertEl) {
            alertEl.scrollIntoView({ behavior: 'smooth' });
        }
    }

    return (
        <Collapse in={open}>
            <Alert 
                id="notification-alert"
                severity={severity} 
                action={
                    <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={handleClose}
                    >
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                }
                sx={{ width: {
                        xs:'80%',
                        sm: '70%',
                        md: '50%'
                        },
                    zIndex: 100, 
                    margin: 'auto', 
                    my: 2 
                    }}>
                {message}
            </Alert>
        </Collapse>
    )
}

export default Notification;